import { render } from "./QuickImageButton.vue?vue&type=template&id=3e7e76d4&scoped=true"
import script from "./QuickImageButton.vue?vue&type=script&lang=js"
export * from "./QuickImageButton.vue?vue&type=script&lang=js"

import "./QuickImageButton.vue?vue&type=style&index=0&id=3e7e76d4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3e7e76d4"

export default script